import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

import { BaasLink } from '../baas-link/baas-link';
import { BaasLinkOptions } from '../baas-link/baas-link-options.type';
import { BaasBreadcrumbOptions } from './baas-breadcrumb-options.type';

@Component({
    selector: 'baas-breadcrumb',
    templateUrl: './baas-breadcrumb.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MatIconModule, BaasLink]
})
export class BaasBreadcrumb {
    /** An array of links to use for the breadcrumb. */
    readonly items = input<BaasLinkOptions[]>();
    /** An array of breadcrumbs in case event system is used with navigate. */
    readonly breadcrumbs = input<BaasBreadcrumbOptions[]>();
    readonly breadcrumbLabelField = input('title');
    readonly navigate = output<Record<string, any>>();

    protected navigateCrumb(crumb: BaasBreadcrumbOptions, crumbIndex: number): void {
        this.navigate.emit({ crumb, crumbIndex });
    }

    protected navigateRoot(): void {
        this.navigate.emit({ crumb: null, crumbIndex: -1 });
    }
}
